import { Component } from '@angular/core';

@Component({
  selector: 'calsoft-stepcard-layout',
  templateUrl: './stepcard-layout.component.html',
  styleUrls: ['./stepcard-layout.component.scss']
})
export class StepcardLayoutComponent {
  steps = [
    {
      number: 1,
      icon: 'fas fa-mobile-alt',
      title: 'Enter Your Mobile Number',
      points: [
        'Get instant access link',
        'No email, no password hassle',
        '100% secure OTP login'
      ]
    },
    {
      number: 2,
      icon: 'fas fa-cloud-download-alt',
      title: 'Download the App',
      points: [
        'Available on Google Play Store',
        'iOS app coming soon',
        'Your business in your pocket'
      ],
      isFeatured: true,
      hasActions: true
    },
    {
      number: 3,
      icon: 'fas fa-cogs',
      title: 'Login & Quick Setup',
      points: [
        'Add your team members',
        'Upload or capture leads',
        'Setup in under 2 minutes'
      ]
    }
  ];
}
